export default {"src":"/_next/static/media/ico-more.3aa11197.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};